import $ from "jquery";
window.jQuery = $;
window.$ = $;

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
ActiveStorage.start()

require("bootstrap/dist/js/bootstrap.bundle.js")

require("theme/jquery.maskedinput.js")

require("popper.js")

require("outer_theme_1/bootstrap.min.js")
require("outer_theme_1/owl.carousel.min.js")
require("outer_theme_1/magnific-popup.min.js")
// require("outer_theme_1/waypoints.min.js")
require("outer_theme_1/parallax.js")
require("outer_theme_1/jquery.countdown.min.js")
require("outer_theme_1/imagesloaded.pkgd.min.js")
require("outer_theme_1/isotope.min.js")
require("outer_theme_1/jquery.dd.min.js")
require("outer_theme_1/slick.min.js")
require("outer_theme_1/jquery.elevatezoom.js")
require("outer_theme_1/scripts.js")
require("theme/jquery.toast.js")
require("theme/bootbox.min.js")


$(document).ready(function () {
  $(".custome_select").msDropdown();

  $('.owl-carousel').owlCarousel();
});

$(document).ready(function () {
  $(".phone_no_masked").mask("(999) 999-9999");
  confirm_rails();
});

function confirm_rails() {
  $(document).on('mousedown', 'a[data-confirm]', function (e) {
    console.log('hii');
    let $ = window.$b;
    e.preventDefault();
    let link = window.jQuery(this)
    let message = link.data('confirm');
    let modal = window.jQuery("#modal_confirm");
    modal.find('.modal-body').text(message)
    let approve = modal.find('.approve')
    approve.attr('data-method', link.data('method'));
    approve.attr('href', link.attr('href'));
    modal.modal('show')
  });
}
